import React from 'react';
import { graphql } from 'gatsby';

import BaseSimulationBlock from './BaseSimulationBlock';

type Props = {
  id: string;
  locale: 'en' | 'fr' | 'nl';
  disclaimer: {
    text: { text: string };
  };
};

const KeyprivateSimulationBlock: React.FC<Props> = ({
  locale,
  id,
  disclaimer,
}) => (
  <BaseSimulationBlock
    simulationType='keyprivate'
    locale={locale}
    id={id}
    minHeight='236px'
    disclaimer={disclaimer?.text?.text}
  />
);

export default KeyprivateSimulationBlock;

export const keyprivateSimulationBlockFragmentQuery = graphql`
  fragment KeyprivateSimulationBlockFragment on ContentfulKeyprivateSimulationBlock {
    id
    __typename
    disclaimer {
      ...DisclaimerFragment
    }
  }
`;
